(function () {
    'use strict';

    angular
    .module('app')
    .directive('onFileChange', function() {
        return {
            restrict: 'A',
            scope: {
                onFileChange: '='
            },
            link: function (scope, element) {
                element.on('change', function() {
                    scope.$apply(function() {
                        var files = element[0].files;
                        if (files) {
                            scope.onFileChange = files[0];
                        }
                        delete element[0].files[0];
                    });
                });

            }
        };
    });
})();